var classNames = {
	"stroke-accent-class": "stroke-accent",
	"accent-class": "with-accent"
};

var ACCENT_CLASS = classNames['accent-class'];
var STROKE_ACCENT_CLASS = classNames['stroke-accent-class'];

var SETS = {
  bauhaus: {
    prefix: 'icon'
  },
  feather: {
    prefix: 'i'
  },
  hover: {
    prefix: 'h'
  },
  pictogram: {
    prefix: 'pictogram'
  }
};

export { ACCENT_CLASS, SETS, STROKE_ACCENT_CLASS };
